<template>
  <div class="result">
    <div class="flex-box">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="企业测评" key="result"></a-tab-pane>
      </a-tabs>
			<a-button  @click="onBack" v-if="isBack">返回</a-button>
    </div>
    <div class="report">
      <div class="header">
        <div>{{ isTech ? '科技型中小企业测评' : '企业规模类型自测' }}</div>
        <div>{{ isTech ? techInfo.companyName : scaleInfo.companyName}}</div>
      </div>
      <div class="body">
        <div class="top-info">
          <div class="tit">
            {{
              isTech ? '科技型中小企业测评分析报告' : '企业规模类型自测分析报告'
            }}
          </div>
          <div class="remark">
            {{
              isTech
                ? '特别提示：科技型中小企业的研发费用加计扣除比例提高到75%'
                : '特别申明：根据《中小企业划型标准规定》（工信部联企业[2011]300号），按照您提供的企业所属行业和指标数据生成测评结果'
            }}
          </div>
        </div>
        <div class="info">
          <div class="title">
            <span class="desc1"></span>
            <span class="desc2">企业信息</span>
          </div>
          <div class="info-cont" v-if="!isTech">
            <div class="item-key">
              所在行业名称：<span class="item-value">{{
                scaleInfo.industryDesc
              }}</span>
            </div>
            <div class="item-key" v-if="scaleInfo.lastYearEndEmpNum">
              上一年末从业人数：<span class="item-value"
                >{{ scaleInfo.lastYearEndEmpNum }}人</span
              >
            </div>
            <div class="item-key" v-if="scaleInfo.lastYearEndOperatingIncome">
              上一年末营业收入：<span class="item-value"
                >{{ scaleInfo.lastYearEndOperatingIncome }}万元</span
              >
            </div>
            <div class="item-key" v-if="scaleInfo.lastYearEndTotalAssets">
              上一年末资产总额：<span class="item-value"
                >{{ scaleInfo.lastYearEndTotalAssets }}万元</span
              >
            </div>
          </div>
          <div class="info-cont" v-if="isTech">
            <div class="item-key">
              <img
                v-if="entInfo.registerAddress"
                src="../../assets/images/success.png"
              />
              <img
                v-if="!entInfo.registerAddress"
                src="../../assets/images/error.png"
              />
              {{ techInfo.registerAddress }}
            </div>
            <div class="item-key">
              <img
                v-if="entInfo.enterpriseSize"
                src="../../assets/images/success.png"
              />
              <img
                v-if="!entInfo.enterpriseSize"
                src="../../assets/images/error.png"
              />
              {{ techInfo.enterpriseSize }}
            </div>
            <div class="item-key">
              <img
                v-if="entInfo.productAndServiceRange"
                src="../../assets/images/success.png"
              />
              <img
                v-if="!entInfo.productAndServiceRange"
                src="../../assets/images/error.png"
              />
              {{ techInfo.productAndServiceRange }}
            </div>
            <div class="item-key">
              <img
                v-if="entInfo.enterpriseCredit"
                src="../../assets/images/success.png"
              />
              <img
                v-if="!entInfo.enterpriseCredit"
                src="../../assets/images/error.png"
              />
              {{ techInfo.enterpriseCredit }}
            </div>
          </div>
        </div>
        <div class="info">
          <div class="title">
            <span class="desc1"></span>
            <span class="desc2">测评结果</span>
          </div>
          <div class="cont">
            <div class="cont-info" v-if="!isTech">
              贵公司的企业规模类型为：<span class="txt">{{
                scaleInfo.enterpriseSize
              }}</span>
            </div>
            <div class="cont-info2" v-if="isTech">
              {{ techInfo.enterpriseTechEva }}
            </div>
            <img class="bg-img1" src="../../assets/images/img1.png" />
            <img class="bg-img2" src="../../assets/images/img2.png" />
            <img class="bg-img3" src="../../assets/images/img3.png" />
          </div>
        </div>
        <div class="info">
          <div class="title">
            <span class="desc1"></span>
            <span class="desc2"
              >推荐与【{{
                isTech ? '科技型企业' : scaleInfo.enterpriseSize
              }}】相关政策</span
            >
          </div>
          <div
            class="item"
            v-for="(item, index) in policyList"
            :key="index + 'policyList'"
            @click="goToDetail(item.id)"
          >
            <div class="policy-name">{{ item.policyName }}</div>
            <div class="item-key">
              最高资助金额：<span class="item-value">{{
                item.maxIncentive ? item.maxIncentive + '万元' : '-'
              }}</span>
            </div>
            <div class="item-key">
              申报状态：<span class="item-value">{{
                getApplyState(item.applyStartTime, item.applyEndTime)
              }}</span>
            </div>
            <div class="item-key">
              受理部门：<span class="item-value">{{ item.deptFullName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listByEntSize, listByTechBasesSmes } from '@/api/enterpriseScale';
export default {
  data() {
    return {
      isTech: false,
      activeName: 'result',
      nowTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),

      scaleInfo: {},
      entInfo: {},
      techInfo: {},
      policyList: [],
      isBack: false
    };
  },
  mounted() {
    if (this.$route.query.isTech == 'true') {
      this.isTech = true;
    }
    this.init();
  },
  created() {
    if (this.$route.query.source == "zjtx") {
      this.isBack = true;
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push('/policyDetail?cid=-1&targetId=' + id);
    },
    getApplyState(beginTime, endTime) {
      if (beginTime > this.nowTime) {
        return '未开始';
      } else if (beginTime < this.nowTime && this.nowTime < endTime) {
        return '可申报';
      } else if (endTime < this.nowTime) {
        return '已结束';
      } else {
        return '-';
      }
    },
    //初始化数据
    init() {
      if (this.isTech) {
        let techParams = JSON.parse(localStorage.getItem('techParams'));
        this.entInfo = techParams;
        let techResult = JSON.parse(localStorage.getItem('techResult'));
        this.techInfo = techResult;
        this.getListByTechBasesSmes();
      } else {
        let scaleResult = JSON.parse(localStorage.getItem('scaleResult'));
        this.scaleInfo = scaleResult;
        this.getListByEntSize();
      }
    },
    //根据企业规模查询政策列表
    getListByEntSize() {
      let param = {
        entSize: this.scaleInfo.enterpriseSize,
        companyName: this.isTech ? this.techInfo.companyName : this.scaleInfo.companyName
      };
      listByEntSize(param).then((res) => {
        if (res.code == 0) {
          this.policyList = res.data;
        }
      });
    },
    //查询符合科技型中小企业条件的政策列表
    getListByTechBasesSmes() {
      listByTechBasesSmes({
        companyName: this.isTech ? this.techInfo.companyName : this.scaleInfo.companyName
      }).then((res) => {
        if (res.code == 0) {
          this.policyList = res.data;
        }
      });
    },
    onBack(){
			this.$router.go(-2)
		}
  },
};
</script>

<style lang="less" scoped>
.result {
  padding: 20px;
  .flex-box{
		display: flex;
		height: 36px;
		justify-content: space-between;
		border-bottom: 1px solid #e8e8e8;
		// margin-bottom: 16px;
	}

  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 12px 0;
  }

  ::v-deep .ant-tabs-tab {
    padding-top: 0;
  }

  ::v-deep .ant-tabs-ink-bar {
    width: 64px !important;
    background-color: #0072f7;
  }

  .report {
    border: 1px solid #f0f0f0;
    margin-top: 20px;
    .header {
      padding: 5px 20px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px;
      color: #999999;
    }

    .body {
      padding: 30px 30px 0 20px;

      .top-info {
        .tit {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }

        .remark {
          color: #999999;
          margin-top: 14px;
        }
      }

      .info {
        .title {
          margin: 30px 0 20px;
          display: flex;
          align-items: center;

          .desc1 {
            display: inline-block;
            width: 3px;
            height: 14px;
            background: #0072f7;
          }

          .desc2 {
            margin-left: 9px;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            line-height: 16px;
          }
        }

        p {
          margin-bottom: 20px;
          text-indent: 12px;

          span {
            color: #666;
          }
        }

        .cont {
          height: 126px;
          background: #f7fafe;
          line-height: 126px;
          text-align: center;
          position: relative;
          margin-left: 12px;

          .cont-info {
            font-size: 16px;
            color: #333333;

            .txt {
              font-size: 20px;
              font-weight: 600;
              color: #0072f7;
            }
          }

          .cont-info2 {
            font-size: 20px;
            font-weight: 600;
            color: #0072f7;
          }

          img {
            position: absolute;
          }

          .bg-img1 {
            left: 2px;
            top: 6px;
          }

          .bg-img2 {
            left: 238px;
            bottom: 15px;
          }

          .bg-img3 {
            top: 10px;
            right: 7px;
          }
        }

        .item {
          height: 152px;
          background: #ffffff;
          border: 1px solid #f0f0f0;
          margin-left: 12px;
          margin-bottom: 20px;
          padding: 24px 20px;
          line-height: 26px;

          .policy-name {
            color: #0072f7;

            &:hover {
              text-decoration: underline;
              cursor: pointer;
            }
          }

          .item-key {
            .item-value {
              color: #666666;
            }
          }
        }

        .info-cont {
          padding-left: 12px;
          line-height: 30px;

          .policy-name {
            color: #0072f7;
          }

          .item-key {
            display: flex;
            align-items: center;
            img {
              width: 16px;
              margin-right: 10px;
            }
            .item-value {
              color: #666666;
            }
          }
        }
      }
    }
  }
}
</style>
